module.exports = __webpack_public_path__ + "static/media/53.226d10d2.jpg";